(function($) {
    $(document).ready(function() {
        reviews();
    })
    function reviews() {
        var sections = $('.section.reviews_section');
        sections.each(function() {
            var section = $(this)
            var wrap = section.find('.reviews .slider');

            if (wrap.length > 0) {
                wrap.slick({
                    autoplay: false,
                    arrows: false,
                    dots: true,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    centerMode: false,
                    nextArrow: wrap.closest('.reviews').find('.next'),
                    prevArrow: wrap.closest('.reviews').find('.prev'),
                    appendDots: wrap.closest('.section').find('.pager'),
                    rtl: $('html').attr('dir') === 'rtl',
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                adaptiveHeight: true
                            }
                        },
                    ]
                });
            }
        })

    }

})(jQuery);